import Vue from 'vue'
import { createI18n } from 'vue-i18n'
import string from './i18n/string.json'

const messages = {
    "en": string.en,
    "zh": string.zh
}


function mapLanguageCode(language) {
    if (language === 'zh-CN' || language === 'zh') {
        return 'zh';
    } else if(language === 'en-US' || language === 'en') {
        return 'en';
    } else {
        return language;
    }
}



let language='zh'
var userAgent = navigator.userAgent;
if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)&&window.miniImsp) {
	language=window.miniImsp.language=='en-US'?'en':'zh';
}else{
	let languageCode = window.android?window.android.getCurrentLanguage():'zh-CN'; //zh zh-CN zh-HK zh-TW en en-US en-GB ja ko ru
	language =mapLanguageCode(languageCode); //english  simplifiedChinese
}


const i18n =createI18n({
    locale: messages[language]?language:'en',
    fallbackLocale: 'en',
    messages, 
  })

export default i18n